
import Iost from "../../../assets/duotone/Iost.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function IostIcon({ className, dataTestid = "IostIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Iost data-testid={dataTestid} className={classes} {...rest} />
  );
}
